'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

exports.wrapDispatch = wrapDispatch;

var _hashIt = require('hash-it');

var _hashIt2 = _interopRequireDefault(_hashIt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var throttled = new _map2.default();
var run = function run(func, args) {
    return (0, func).apply(undefined, (0, _toConsumableArray3.default)(args));
};

/**
 * Debounce implementation that will group all calls made until
 * the next tick into a single function call on the leading edge.
 *
 * Any calls past this tick will be debounced until `timeout`
 * has expired, just like a normal debounce.
 *
 * After the trailing edge invocation the debounce method is reset
 * and the flow resets to invoking the leading edge.
 */
function _debounce(func, timeout) {
    var state = 'leading';
    var result = null;
    var timer = null;

    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // Leading edge
        if (state == 'leading') {
            result = run(func, args);
            state = 'wait';

            // Allow trailing to run on next tick
            setTimeout(function () {
                state = 'trailing';
            }, 0);
            return result;
        }

        // Do nothing if within 10ms from leading edge
        if (state == 'wait') return result;

        // New invocation, cancel previous invocation
        if (timer) clearTimeout(timer);

        // Schedule new invocation
        timer = setTimeout(function () {
            result = run(func, args);
            state = 'leading';
            timer = null;
        }, timeout);

        // Return the result of the last invocation
        return result;
    };
}

function __debounce(func, timeout, opts) {
    var cache = {};

    return function () {
        var key = opts.id.apply(opts, arguments);

        if (!cache[key]) cache[key] = _debounce(func, timeout);

        return (0, cache[key]).apply(undefined, arguments);
    };
}

function wrapDispatch(dispatch) {
    if (throttled.has(dispatch)) return throttled.get(dispatch);

    var wrapper = __debounce(dispatch, 1000, {
        id: function id() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return (0, _hashIt2.default)(args);
        }
    });

    throttled.set(dispatch, wrapper);

    return wrapper;
}